module.exports = __webpack_public_path__ + "media/images/area/feature/shikoku/related/vi/2-bd76c8beb97406fd155db3354c1af3e6.jpg";